import React from 'react';
import { Card } from 'react-bootstrap';
import { UseWindowDimensions } from '../../utils/getSizeScreen';
const Layout = (props) => {
    const screen = UseWindowDimensions();
    return (
        <Card 
        className={`${screen.width<800?'wm-100':'w-75 p-3'}`} style={{margin: "auto"}}
        >
            {props.children}
        </Card>
    )
}

export default Layout;